import { alpha, createTheme, lighten } from "@mui/material";
import { esES } from "@mui/material/locale";

export const themeMui = createTheme({
  palette: {
    primary: {
      light: lighten("#007864", 0.15),
      main: "#007864",
      dark: "#007864",
      grey: "#bdbbbb",
      menuItem: "#858a93",
      contrastText: "#FFFFFF",
    },
    secondary: {
      light: "#96a834",
      main: "#96a834",
      dark: "#96a834",
      backgroundListItem: "#858a93",
      contrastText: "#FFFFFF",
    },
    tertiary: {
      main: "#0E349E",
      light: "#6ea2ea",
      grey: "#fafafa",
    },
    quartary: {
      main: "#d52b34",
      light: '#d8927d',
    },
    quinary: {
      main: '#802293'
    },
    senary: {
      dark: "#424db8",
      light: "#5c48c7",
    },
    info: {
      main: alpha("#000000", 0.87),
    },
    overrides: {
      MuiCssBaseline: {
        "@global": {
          "*::-webkit-scrollbar": {
            width: "0.6em !important",
            height: "0.6em !important",
          },
          "*::-webkit-scrollbar-track": {
            backgroundColor: "lightgray !important",
            borderRadius: "7px !important",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00) !important",
          },
          "*::-webkit-scrollbar-thumb": {
            backgroundColor: "#a3c5f4 !important",
            borderRadius: "7px !important",
            outline: "1px solid slategrey !important",
            border: "none !important",
          },
        },
      },
      MuiTableCell: {
        root: {
          padding: "4px 2px 4px 2px",
        },
      },
    },
  },
},
  esES,

);
